query Stream($contentId: ID!) {
  content(id: $contentId) {
    id
    title
    description
    publishAt
    accessStartAt
    hideInGeneralLists
    onlyUsers
    ageRestrictions
    viewersOnline
    productIds
    url
    embedUrl
    widget {
      id
    }
    preview {
      id
      url(format: HIGH)
    }
    verticalPreview {
      id
      url
    }
    tags {
      id
      title
    }
    stream {
      id
      status
      liveConnected
      signal {
        state
        since
        checkedAt
      }
      lastPublishAt
      startAt
      startedAt
      finishAt
      entrypoint {
        id
        title
      }
      rtmpsUrl
      rtmpsStreamKey
      srtUrl
      srtStreamId
      srtPassphrase
      enableRecord
      autoPublishRecord
      isChatEnabled
      dvrEnabled
      recordContentId
      recordingTrim {
        status
        startSeconds
        endSeconds
        progress
        error {
          code
          message
        }
      }
      lastError {
        code
        message
      }
      playback {
        token
        hlsUrl
        dashUrl
        iframeUrl
        thumbnailUrl
      }
      recordPlayback {
        token
        hlsUrl
        dashUrl
        iframeUrl
        thumbnailUrl
      }
      restreamDestinationsLimit
      restreamDestinations {
        id
        title
        url
        streamKey
        enabled
      }
      pull {
        sourceUrl
        status
        attempt
        maxAttempts
        startedAt
        finishedAt
        lastError {
          code
          message
        }
      }
    }
  }
}
